<template>
  <footer id="footer">
    <div class="inner_box">
      <v-img src="@/assets/img/common/f_logo.png" alt="" min-width="216" />
      <div class="footerCon"></div>
      <a href="javascript:;" id="btn_top">맨위로</a>
      <a href="javascript:;" id="btn_sitemap">sitemap</a>
      <!--div class="f_top clearfix">
                <img src="/img/common/f_logo.png" alt="" />
                <a href="javascript:;" id="btn_top">맨위로</a>
                <a href="javascript:;" id="btn_sitemap">sitemap</a>
            </div>-->

      <address>
        <span>서울특별시 영등포구 당산로 41길 11 SK V1센터 W동 809호</span>
        <span>TEL : 02-6450-0851</span>
        <span>FAX : 02-6450-0867</span>
        <!-- <span OnClick="location.href='https://blog.naver.com/oncrewsoft'" style="cursor:pointer;">Blog</span> -->
        <span
          OnClick="window.open('https://blog.naver.com/oncrewsoft')"
          style="cursor: pointer"
          >Blog</span
        >
      </address>
      <div class="plink">
        <router-link to="/common/privacyVue"
          >Privacy Policy Terms and</router-link
        >
        <router-link to="/common/serviceVue">Transparency</router-link>
      </div>
    </div>
    <p class="copyright">Copyright ⓒ 온크루소프트 All rights reserved.</p>
  </footer>
</template>

<script>
export default {};
</script>

<style></style>
